"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const lodash_1 = require("lodash");
var Auth;
(function (Auth) {
    function isAccessibleForUser(ar, userId) {
        return (0, lodash_1.some)(ar.usersWithAccess, (id) => id == userId);
    }
    Auth.isAccessibleForUser = isAccessibleForUser;
})(Auth || (exports.Auth = Auth = {}));
//# sourceMappingURL=Auth.js.map